export function caseInsensetiveQueryKeyMatch(searchKey: string, myObj: Object): any {
  const caseInsensetiveKey = Object.keys(myObj).find(
    key => key.toLowerCase() === searchKey.toLowerCase()
  )
  if (!caseInsensetiveKey) return undefined
  return myObj[caseInsensetiveKey]
}
